import React from 'react';
import I18n from 'i18n-js';
import { tv } from 'tailwind-variants';
import Checkbox from '@/components/common/libraries/common/Checkbox';
import useFlags from '@/hooks/useFlags';
import cn from '@/utils/cn';
import styles from './index.module.scss';

interface ShowSlideshowCheckboxProps {
  handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isChecked: boolean;
  isInEditModal?: boolean;
}

const checkboxStyles = tv({
  base: [
    'tw-inline-flex tw-items-center tw-bg-[#247f99] tw-bg-opacity-5',
    'tw-border-[1px] tw-border-solid tw-border-[#247f99] tw-rounded-full tw-px-4 tw-py-2 w-fit',
  ],
  variants: {
    reflow: {
      true: 'tw-mb-4 reflow-narrow:tw-absolute reflow-narrow:tw-top-[-0.5rem] reflow-narrow:-tw-right-2 lg:!tw-right-5',
    },
  },
});

const ShowSlideshowCheckbox = ({
  handleCheckboxChange,
  isChecked,
  isInEditModal = false,
}: ShowSlideshowCheckboxProps) => {
  const { accessibilityReflow } = useFlags();
  const extraClassName = cn(
    checkboxStyles({ reflow: accessibilityReflow && !isInEditModal }),
    !accessibilityReflow && !isInEditModal && 'tw-absolute tw-top-[-0.5rem] tw-right-16',
    isInEditModal && 'tw-absolute tw-mt-4 tw-cursor-default',
  );

  return (
    <Checkbox
      shouldCover
      checked={isChecked}
      extraClassName={extraClassName}
      extraInputClassName={`${styles.checkbox} ${isInEditModal ? 'tw-cursor-default' : ''}`}
      extraLabelClassName="tw-text-[#3c3c3c] tw-tracking-[.03em] tw-leading-relaxed tw-pl-2"
      label={I18n.t('show_my_slideshows')}
      onChange={event => handleCheckboxChange(event)}
    />
  );
};

export default ShowSlideshowCheckbox;
